module.exports = __webpack_public_path__ + "img/24.087737f8.jpg";